import React, {Component} from 'react';
import { connect } from 'react-redux';
import Update from './../clientproduct/Update';

class ProductOptions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isColorPickersVisible: false
    };
  }


  hasClickOnColorPicker = (e) => {
    let a = e.target;
    const els = [];

    while (a) {
      els.unshift(a.className);
      a = a.parentNode;
    }
    if (els.indexOf('picker-square-container') !== -1) {
      this.setState({isColorPickersVisible: true})
    } else {
      this.setState({isColorPickersVisible: false})
    }
  }


  render(){
    return (
      <div onClick={this.hasClickOnColorPicker} className="product-options">
        <Update isColorPickersVisible={this.state.isColorPickersVisible} locale={this.props.locale} clientId={this.props.clientId} id={this.props.id} />
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {

  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductOptions);



// WEBPACK FOOTER //
// ./src/components/client/ProductOptions.js